"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplicationConfig = exports.getApplicationConfigByName = exports.GET_APPLICATION_CONFIGS = void 0;
var API = __importStar(require("../../../api"));
var GET_APPLICATION_CONFIGS;
(function (GET_APPLICATION_CONFIGS) {
    GET_APPLICATION_CONFIGS["REQUEST"] = "GET_APPLICATION_CONFIGS_REQUEST";
    GET_APPLICATION_CONFIGS["SUCCESS"] = "GET_APPLICATION_CONFIGS_SUCCESS";
    GET_APPLICATION_CONFIGS["FAILURE"] = "GET_APPLICATION_CONFIGS_FAILURE";
})(GET_APPLICATION_CONFIGS = exports.GET_APPLICATION_CONFIGS || (exports.GET_APPLICATION_CONFIGS = {}));
var getApplicationConfigByName = function (_a) {
    var keyName = _a.keyName;
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch({
                        type: GET_APPLICATION_CONFIGS.REQUEST,
                        keyName: keyName,
                    });
                    return [4, API.getApplicationConfigByName({
                            keyName: keyName,
                        })];
                case 1:
                    res = _a.sent();
                    dispatch({
                        response: res,
                        keyName: keyName,
                        type: GET_APPLICATION_CONFIGS.SUCCESS,
                    });
                    return [2, res];
                case 2:
                    err_1 = _a.sent();
                    dispatch({
                        type: GET_APPLICATION_CONFIGS.FAILURE,
                        keyName: keyName,
                    });
                    throw err_1;
                case 3: return [2];
            }
        });
    }); };
};
exports.getApplicationConfigByName = getApplicationConfigByName;
var getApplicationConfig = function (keyName) {
    return exports.getApplicationConfigByName({ keyName: keyName });
};
exports.getApplicationConfig = getApplicationConfig;
//# sourceMappingURL=getAppConfigByName.js.map